import Logo from '../../../assets/app/logo.png'
import { Link } from 'react-router-dom';

const FinalStep = ({ type }) => {

    return (
        <>
            {type === 1 ?
                (<div className={"text-center h-[100vh] flex items-center justify-center flex-col gap-7"}>
                    <img className='m-auto my-10' src={Logo} />
                    <p style={{ fontSize: "50px" }}>🎉</p>
                    Welcome to our diverse language platform! <br /> We're excited to have you on board
                    <Link className='no-underline text-white bg-nt-blue py-2 px-5 rounded-md' to={"/"}>Home page</Link>
                </div>)
                :
                (<div className={"text-center h-[100vh] flex items-center justify-center flex-col gap-7"}>
                    <img className='m-auto my-10' src={Logo} />
                    <p style={{ fontSize: "50px" }}>🎉</p>
                    Welcome to our diverse language platform! <br />
                    Your account is under review!
                </div>)
            }
        </>
    )
};

export { FinalStep };
